import { render } from "./DomainPicker.vue?vue&type=template&id=079ecbcc&scoped=true"
import script from "./DomainPicker.vue?vue&type=script&lang=js"
export * from "./DomainPicker.vue?vue&type=script&lang=js"

import "./DomainPicker.vue?vue&type=style&index=0&id=079ecbcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079ecbcc"]])

export default __exports__